import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom';
import { makeApiCall } from '../../services/httpService';
import { BASE_URL } from '../../config';
import toast from 'react-hot-toast';
import AsyncSelect from 'react-select/async';
import Modal from 'react-bootstrap/Modal';
import ContentLoader from '../loader/ContentLoader';
import { CSVLink } from "react-csv";
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

import { useLoadingBar } from 'react-top-loading-bar';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';


const SupplierList = () => {
  const { start, complete } = useLoadingBar({ color: "blue", height: 2 });
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const csvLinkRef = useRef(null);
  const [exportData, setExportData] = useState({
    data: [],
    fileName: 'Suppliers_List'
  });
  const initialSupplierDetail = {
    id: null,
    name: "",
    supplier_code: "",
    agency_name: "",
    head_person: "",
    mobile: "",
    email: "",
    password: "",
    address: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    wallet_balance: 0.00
  };
  const [supplierDetail, setSupplierDetail] = useState(initialSupplierDetail);
  const [addUpdateSupplierHeading, setAddUpdateSupplierHeading] = useState('Add New');
  const [btnAddUpdateSupplierText, setBtnAddUpdateSupplierText] = useState('Save Supplier');
  const [btnAddUpdateSupplierDisabled, setBtnAddUpdateSupplierDisabled] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const [pageValue, setPageValue] = useState(1);
  const [pagingLimit, setPagingLimit] = useState("10");
  const [suppliers, setSuppliers] = useState({
    paginationInfo: {},
    supplierList: []
  });

  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const [pincodeDropdown, setPincodeDropdown] = useState({
    cities: [],
    states: [],
    districts: []
  });
  const [show, setShow] = useState(false);
  const onHideModel = () => {
    setShow(false)
    setSupplierDetail(initialSupplierDetail);
    setAddUpdateSupplierHeading('Add New');
    setBtnAddUpdateSupplierText('Save Supplier');
    setBtnAddUpdateSupplierDisabled(false);
  }

  const onShowModel = () => {
    setShow(true)
  }

  useEffect(() => {
    loadSupplier();
  }, [pagingLimit, pageValue]);

  const loadSupplier = async () => {
    try {
      setLoading(true);
      start();
      let apiUrl = `${BASE_URL}/api/suppliers?page=${pageValue}&limit=${pagingLimit}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log("apiRes", apiRes)
      if (apiRes?.statusCode == 200) {
        setSuppliers({
          paginationInfo: apiRes?.resData?.pagination,
          supplierList: apiRes?.resData?.suppliers || []
        })
      } else {
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
      complete();
    }
  }

  const loadSupplierOptions = async (inputValue) => {
    try {
      let apiUrl = `${BASE_URL}/api/suppliers?page=1&limit=20&search=${inputValue || ""}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      if (apiRes?.statusCode == 200) {
        return (apiRes?.resData?.suppliers || []).map((s) => ({
          value: s.user_id,
          label: `${s.agency_name} (${s.supplier_code})`
        }));
      }
      return [];
    } catch {
      return [];
    }
  };

  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }

  const handlePagingLimit = (e) => {
    setPageValue(1);
    setPagingLimit(e.target.value);
  }

  const handlePagination = (pageValueInput) => {
    setPageValue(pageValueInput);
  }

  const handleSelectChangeSupplier = (selectedOption) => {
    setSelectedSupplier(selectedOption);
  };



  // const handleInactivateSupplier = async (supplierId, supplierRoleId, supplierStatus) => {
  //   customShowSwal(
  //     "Are you sure?",
  //     `Are you sure you want to ${supplierStatus} this supplier?`,
  //     "warning",
  //     async () => {
  //       await toggleSupplierStatus(supplierId, supplierRoleId, supplierStatus);
  //     }
  //   );
  // };

  // const customShowSwal = (title, text, icon, onConfirm) => {
  //   withReactContent(Swal).fire({
  //     title,
  //     text,
  //     icon,
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "No",
  //     allowOutsideClick: false, // ❌ disable outside click
  //     preConfirm: async () => {
  //       let btn = Swal.getConfirmButton();
  //       btn.disabled = true;

  //       // start dot animation
  //       let dots = "";
  //       const interval = setInterval(() => {
  //         dots = dots.length < 3 ? dots + "." : "";
  //         btn.textContent = dots;
  //       }, 500);

  //       try {
  //         if (onConfirm) {
  //           await onConfirm(); // wait for API
  //         }
  //       } catch (err) {
  //         Swal.showValidationMessage(`Request failed: ${err.message}`);
  //         clearInterval(interval);
  //         btn.textContent = "Yes"; // reset button text
  //         btn.disabled = false;
  //         throw err;
  //       }

  //       clearInterval(interval);
  //     }
  //   });
  // };
  const handleInactivateSupplier = async (supplierId, supplierRoleId, supplierStatus) => {
    customShowSwal(
      "Are you sure?",
      `Are you sure you want to ${supplierStatus} this supplier?`,
      "warning",
      async () => {
        await toggleSupplierStatus(supplierId, supplierRoleId, supplierStatus);
      }
    );
  };

  const customShowSwal = (title, text, icon, onConfirm) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
      preConfirm: async () => {
        let btn = Swal.getConfirmButton();
        btn.disabled = true;

        // Replace button content with dots loader
        btn.innerHTML = `
        <span class="dot-loader">
          <span></span><span></span><span></span>
        </span>
      `;

        // Inject CSS for dots animation (only once)
        if (!document.getElementById("swal-dot-style")) {
          const style = document.createElement("style");
          style.id = "swal-dot-style";
          style.innerHTML = `
          .dot-loader {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            height: 24px;
          }
          .dot-loader span {
            width: 6px;
            height: 6px;
            background: white;
            border-radius: 50%;
            display: inline-block;
            animation: dot-bounce 1.2s infinite;
          }
          .dot-loader span:nth-child(2) {
            animation-delay: 0.2s;
          }
          .dot-loader span:nth-child(3) {
            animation-delay: 0.4s;
          }
          @keyframes dot-bounce {
            0%, 80%, 100% { transform: scale(0.6); }
            40% { transform: scale(1); }
          }
        `;
          document.head.appendChild(style);
        }

        try {
          if (onConfirm) {
            await onConfirm();
          }
        } catch (err) {
          Swal.showValidationMessage(`Request failed: ${err.message}`);
          btn.innerHTML = "Yes";  // reset button text
          btn.disabled = false;
          throw err;
        }
      }
    });
  };


  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const toggleSupplierStatus = async (supplierId, supplierRoleId, supplierStatus) => {
    try {
      setLoading(true);
      await delay(1000);
      let bodyPayload = { user_id: supplierId, role_id: supplierRoleId, status: supplierStatus };
      let apiUrl = `${BASE_URL}/api/users/toggle-status`;
      let apiRes = await makeApiCall("POST", bodyPayload, apiUrl);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
      } else {
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          showSwal("Error", apiRes?.message, "error");
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
      loadSupplier();
    }
  }

  const loadPincodeInfo = async (pincode) => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/pincode?pin=${pincode}`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      if (apiRes?.statusCode == 200) {
        setPincodeDropdown(apiRes?.resData);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    }
  }

  const findMatchedValue = (list = [], value = "") => {
    const target = String(value || "").trim().toLowerCase();
    const match = list.find((item) => String(item || "").trim().toLowerCase() === target);
    return match || value || "";
  };

  const handleUpdateSupplier = async (supplierArgs) => {
    setAddUpdateSupplierHeading("Update");
    setBtnAddUpdateSupplierText("Update Supplier");
    setShow(true);

    const pincodeData = await loadPincodeInfo(supplierArgs?.pincode);

    const normalizedCity = findMatchedValue(pincodeData?.cities, supplierArgs?.city);
    const normalizedState = findMatchedValue(pincodeData?.states, supplierArgs?.state);

    setSupplierDetail({
      ...supplierArgs,
      city: normalizedCity,
      state: normalizedState
    });
  };

  const onSupplierSubmit = async (e) => {
    e.preventDefault();
    if (supplierDetail.id === null) {
      SaveSupplierDetails();
    }
    else {
      UpdateSupplierDetails();
    }
  }

  const SaveSupplierDetails = async () => {
    try {
      setBtnAddUpdateSupplierText("Please wait...");
      setBtnAddUpdateSupplierDisabled(true);
      await delay(1000);
      let apiUrl = `${BASE_URL}/api/suppliers`;
      let apiRes = await makeApiCall("POST", supplierDetail, apiUrl);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        setShow(false);
        setSupplierDetail(initialSupplierDetail);
        loadSupplier();
      } else {
        //console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setBtnAddUpdateSupplierDisabled(false);
      setAddUpdateSupplierHeading('Add New');
      setBtnAddUpdateSupplierText('Save Supplier');
    }
  }

  const UpdateSupplierDetails = async () => {
    try {
      let bodyPayload = {};
      setBtnAddUpdateSupplierText("Please wait...");
      setBtnAddUpdateSupplierDisabled(true);
      await delay(1000);

      let apiUrl = `${BASE_URL}/api/users/${supplierDetail.user_id}`;
      let apiRes = await makeApiCall("PATCH", supplierDetail, apiUrl);

      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        setShow(false);
        setSupplierDetail(initialSupplierDetail);
        loadSupplier();
        setAddUpdateSupplierHeading('Add New');
        setBtnAddUpdateSupplierText('Save Supplier');
      } else {
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
        setBtnAddUpdateSupplierText('Update Supplier');
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error");
      setBtnAddUpdateSupplierText('Update Supplier');
    } finally {
      setBtnAddUpdateSupplierDisabled(false);
    }
  }

  const handleChange = (e) => {
    setSupplierDetail({ ...supplierDetail, [e.target.name]: e.target.value });
  }

  const handlePincodeChange = async (e) => {
    const pincodeValue = (e.target.value || "").replace(/\D/g, "").slice(0, 6);

    setSupplierDetail((prev) => ({
      ...prev,
      pincode: pincodeValue
    }));

    if (pincodeValue.length === 6) {
      const pincodeData = await loadPincodeInfo(pincodeValue);

      if (pincodeData) {
        setPincodeDropdown(pincodeData);
        setSupplierDetail((prev) => ({
          ...prev,
          city: pincodeData?.cities?.[0] || "",
          state: pincodeData?.states?.[0] || ""
        }));
      }
    }
  };

  // CSV Export functionality
  const handleExportSuppliers = async () => {
    setIsExporting(true);

    try {
      // Get all suppliers for export (without pagination limit)
      let apiUrl = `${BASE_URL}/api/users/all-users?page=1&limit=10000`; // Large limit to get all
      let payload = {
        userType: "supplier",
        userStatus: "all"
      }
      let apiRes = await makeApiCall("POST", payload, apiUrl);

      if (apiRes?.statusCode == 200) {
        const exportSuppliers = apiRes.resData?.users || [];

        // Format data for CSV export
        const csvData = exportSuppliers.map((supplier, index) => ({
          'S.No': index + 1,
          'Supplier Name': supplier.name || '',
          'Supplier Code': supplier.supplier_code || '',
          'Agency Name': supplier.agency_name || '',
          'Mobile': supplier.mobile || '',
          'Email': supplier.email || '',
          'Address': supplier.address || '',
          'City': supplier.city || '',
          'State': supplier.state || '',
          'Country': supplier.country || '',
          'Pincode': supplier.pincode || '',
          'Head Person': supplier.head_person || '',
          'Wallet Balance': supplier.wallet_balance || '0.00',
          'Status': supplier.status || '',
          'Created Date': supplier.created_at || '',
        }));

        // Update export data state
        const currentDate = new Date().toISOString().split('T')[0];
        setExportData({
          data: csvData,
          fileName: `Suppliers_List_${currentDate}`
        });

        // Check if running in Capacitor (mobile app)
        if (Capacitor.isNativePlatform()) {
          await downloadFileInApp(csvData, `Suppliers_List_${currentDate}`);
        } else {
          // For web browsers, use the CSVLink approach
          setTimeout(() => {
            if (csvLinkRef.current) {
              csvLinkRef.current.link.click();
            }
          }, 100);
        }

        toast.success(`Successfully exported ${csvData.length} suppliers`);
      } else {
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (error) {
      toast.error('Failed to export suppliers');
      console.error('Export error:', error);
      showSwal("Error", "Something went wrong while exporting...", "error")
    } finally {
      setIsExporting(false);
    }
  };

  const downloadFileInApp = async (data, fileName) => {
    try {
      // Convert data to CSV string
      const csvContent = convertToCSV(data);

      // Write file to device storage
      const result = await Filesystem.writeFile({
        path: `${fileName}.csv`,
        data: csvContent,
        directory: Directory.Documents,
        encoding: Encoding.UTF8
      });

      toast.success('File downloaded successfully!');
    } catch (error) {
      console.error('Error downloading file in app:', error);

      // Fallback: try to save to Downloads directory
      try {
        const csvContent = convertToCSV(data);
        await Filesystem.writeFile({
          path: `${fileName}.csv`,
          data: csvContent,
          directory: Directory.ExternalStorage,
          encoding: Encoding.UTF8
        });
        toast.success(`File saved to Downloads folder as ${fileName}.csv`);
      } catch (fallbackError) {
        console.error('Fallback download also failed:', fallbackError);
        toast.error('Failed to download file. Please try again.');
      }
    }
  };

  const convertToCSV = (data) => {
    if (!data || data.length === 0) return '';

    // Get headers from the first object
    const headers = Object.keys(data[0]);
    const csvHeaders = headers.join(',');

    // Convert data rows to CSV format
    const csvRows = data.map(row => {
      return headers.map(header => {
        const value = row[header];
        // Handle values with commas, quotes, or newlines
        if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',');
    });

    return [csvHeaders, ...csvRows].join('\n');
  };

  return (
    <>
      <section className="section dashboard">
        {/* Filter Card */}
        <div className="row mb-3">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "14px" }}>
              <div className="card-body py-3 px-4">
                <div className="row g-3 align-items-end">
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-building me-1"></i> Supplier
                    </label>
                    <AsyncSelect
                      cacheOptions
                      name="supplier_dropdown"
                      placeholder="Search supplier..."
                      loadOptions={loadSupplierOptions}
                      onChange={handleSelectChangeSupplier}
                      value={selectedSupplier}
                      defaultOptions={true}
                      isClearable
                      isSearchable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "8px",
                          border: "1.5px solid #dde3ef",
                          fontSize: "13px",
                          minHeight: "38px",
                          boxShadow: "none",
                          "&:hover": { borderColor: "#1a3a8f" }
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-calendar-event me-1"></i> From Date
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="txtFromDate"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px", height: "38px" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>
                      <i className="bi bi-calendar-check me-1"></i> To Date
                    </label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="txtToDate"
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px", height: "38px" }}
                    />
                  </div>
                  <div className="col-md-3 d-flex gap-2">
                    <button
                      type="submit"
                      className="btn btn-sm fw-semibold d-flex align-items-center gap-2 flex-fill justify-content-center text-white"
                      style={{
                        background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                        borderRadius: "8px", border: "none",
                        boxShadow: "0 4px 12px rgba(15,37,87,0.25)",
                        height: "38px", fontSize: "13px"
                      }}
                    >
                      <i className="fa-solid fa-magnifying-glass"></i> Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm fw-semibold d-flex align-items-center gap-2 flex-fill justify-content-center"
                      onClick={handleExportSuppliers}
                      disabled={isExporting}
                      style={{
                        background: isExporting ? "#e9ecef" : "linear-gradient(135deg, #198754, #20c997)",
                        color: "white", borderRadius: "8px", border: "none",
                        boxShadow: "0 4px 12px rgba(25,135,84,0.25)",
                        height: "38px", fontSize: "13px"
                      }}
                    >
                      <i className={`fa-solid ${isExporting ? 'fa-spinner fa-spin' : 'fa-cloud-arrow-down'}`}></i>
                      {isExporting ? 'Exporting...' : 'Export'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "14px", position: "relative" }}>
              <div className="card-body pb-0 px-4 pt-3">

                {/* Card Header */}
                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2 mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <div style={{
                      width: "34px", height: "34px", borderRadius: "9px",
                      background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0
                    }}>
                      <i className="bi bi-people-fill text-white" style={{ fontSize: "14px" }}></i>
                    </div>
                    <div>
                      <h6 className="mb-0 fw-bold" style={{ color: "#0f2557", fontSize: "14px" }}>Supplier Directory</h6>
                      <span style={{ fontSize: "11px", color: "#8a9ab5" }}>
                        Total: <strong style={{ color: "#1a3a8f" }}>{suppliers?.paginationInfo?.totalRecords ?? 0}</strong> records
                      </span>
                    </div>
                  </div>

                  {/* d-grid = full width on mobile, d-sm-block = natural width on desktop */}
                  <div className="d-grid d-sm-block">
                    <button
                      type="button"
                      className="btn btn-sm fw-semibold d-flex align-items-center justify-content-center gap-2 text-white"
                      onClick={onShowModel}
                      style={{
                        background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                        borderRadius: "8px", border: "none",
                        boxShadow: "0 4px 12px rgba(15,37,87,0.25)",
                        fontSize: "13px", height: "34px", padding: "0 16px"
                      }}
                    >
                      <i className="bi bi-person-fill-add"></i> Add Supplier
                    </button>
                  </div>
                </div>
                {/* Loading Overlay */}
                {loading && (
                  <div style={{
                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(255,255,255,0.7)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    zIndex: 10, borderRadius: "14px"
                  }}>
                    <ContentLoader loaderType="circleSpin" />
                  </div>
                )}

                {/* Table */}
                <div className="table-responsive" style={{ height: "calc(100vh - 460px)" }}>
                  <table className="table table-hover mb-0" style={{ fontSize: "13px" }}>
                    <thead>
                      <tr style={{ background: "#f4f6fb" }}>
                        {["Supplier Name", "Supplier ID", "Agency Name", "Mobile", "Email", "Address", "City", "State", "Date", "Balance", ""].map((h, i) => (
                          <th key={i} style={{
                            fontSize: "11px", fontWeight: "700", color: "#8a9ab5",
                            textTransform: "uppercase", letterSpacing: "0.6px",
                            border: "none", padding: "10px 12px", whiteSpace: "nowrap",
                            background: "#f4f6fb"
                          }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {suppliers?.supplierList?.length > 0 ? (
                        suppliers.supplierList.map((supplier, index) => (
                          <tr key={index} style={{ borderBottom: "1px solid #f0f2f8", verticalAlign: "middle" }}>
                            <td style={{ padding: "10px 12px", fontWeight: "600", color: "#0f2557" }}>
                              <div className="d-flex align-items-center gap-2">
                                <div style={{
                                  width: "28px", height: "28px", borderRadius: "50%",
                                  background: "linear-gradient(135deg, #eef0ff, #dde3ef)",
                                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                                }}>
                                  <i className="bi bi-person-fill" style={{ fontSize: "12px", color: "#1a3a8f" }}></i>
                                </div>
                                {supplier?.head_person}
                              </div>
                            </td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                background: "#eef0ff", color: "#1a3a8f",
                                borderRadius: "6px", padding: "2px 8px",
                                fontSize: "11px", fontWeight: "700"
                              }}>{supplier?.supplier_code}</span>
                            </td>
                            <td style={{ padding: "10px 12px", color: "#374151" }}>{supplier?.agency_name}</td>
                            <td style={{ padding: "10px 12px", color: "#374151" }}>
                              <i className="bi bi-telephone-fill me-1" style={{ color: "#8a9ab5", fontSize: "11px" }}></i>
                              {supplier?.mobile}
                            </td>
                            <td style={{ padding: "10px 12px", color: "#374151" }}>
                              <i className="bi bi-envelope-fill me-1" style={{ color: "#8a9ab5", fontSize: "11px" }}></i>
                              {supplier?.email}
                            </td>
                            <td style={{ padding: "10px 12px", color: "#6b7280", maxWidth: "160px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{supplier?.address}</td>
                            <td style={{ padding: "10px 12px", color: "#374151" }}>{supplier?.city}</td>
                            <td style={{ padding: "10px 12px", color: "#374151" }}>{supplier?.state}</td>
                            <td style={{ padding: "10px 12px", color: "#6b7280", whiteSpace: "nowrap" }}>{supplier?.created_at ? new Date(supplier.created_at).toLocaleDateString() : ""}</td>
                            <td style={{ padding: "10px 12px" }}>
                              <span style={{
                                background: "#ecfdf5", color: "#065f46",
                                borderRadius: "6px", padding: "3px 8px",
                                fontSize: "12px", fontWeight: "700"
                              }}>₹ {supplier?.wallet_balance}</span>
                            </td>
                            <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>
                              <button
                                className="btn btn-sm me-1"
                                onClick={() => handleUpdateSupplier(supplier?.supplier)}
                                title="Edit"
                                style={{
                                  background: "#eef0ff", color: "#1a3a8f",
                                  border: "none", borderRadius: "7px",
                                  width: "30px", height: "30px", padding: 0
                                }}
                              >
                                <i className="bi bi-pencil-fill" style={{ fontSize: "11px" }}></i>
                              </button>
                              {supplier?.status === "active" ? (
                                <button
                                  className="btn btn-sm"
                                  onClick={() => handleInactivateSupplier(supplier?.userId, supplier?.roleId, "inactive")}
                                  title="Deactivate"
                                  style={{
                                    background: "#fff1f1", color: "#dc2626",
                                    border: "none", borderRadius: "7px",
                                    width: "30px", height: "30px", padding: 0
                                  }}
                                >
                                  <i className="bi bi-trash-fill" style={{ fontSize: "11px" }}></i>
                                </button>
                              ) : (
                                <button
                                  className="btn btn-sm"
                                  onClick={() => handleInactivateSupplier(supplier?.userId, supplier?.roleId, "active")}
                                  title="Activate"
                                  style={{
                                    background: "#ecfdf5", color: "#065f46",
                                    border: "none", borderRadius: "7px",
                                    width: "30px", height: "30px", padding: 0
                                  }}
                                >
                                  <i className="bi bi-arrow-counterclockwise" style={{ fontSize: "11px" }}></i>
                                </button>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center py-5">
                            <div style={{ color: "#8a9ab5" }}>
                              <i className="bi bi-inbox" style={{ fontSize: "36px", display: "block", marginBottom: "8px" }}></i>
                              <span style={{ fontSize: "13px" }}>No supplier found</span>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex align-items-center justify-content-between py-3" style={{ borderTop: "1px solid #f0f2f8" }}>
                  <div className="d-flex align-items-center gap-2">
                    <select
                      className="form-select form-select-sm"
                      id="paginationRows"
                      aria-label="Pagination Rows"
                      onChange={handlePagingLimit}
                      style={{ width: "75px", borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "12px" }}
                    >
                      {["10", "20", "50", "100", "500"].map(v => (
                        <option key={v} value={v} selected={pagingLimit === v}>{v}</option>
                      ))}
                    </select>
                    <span style={{ fontSize: "12px", color: "#8a9ab5", whiteSpace: "nowrap" }}>Records per page</span>
                  </div>

                  <ul className="pagination pagination-sm mb-0 gap-1">
                    <li className={`page-item ${pageValue === 1 ? "disabled" : ""}`}>
                      <Link className="page-link" onClick={() => handlePagination(pageValue - 1)}
                        style={{ borderRadius: "7px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "12px", padding: "4px 10px" }}>
                        <i className="fa-solid fa-angle-left"></i>
                      </Link>
                    </li>
                    {Array.from({ length: suppliers?.paginationInfo?.totalPage }, (_, i) => (
                      <li className="page-item" key={i}>
                        <Link
                          className="page-link"
                          onClick={() => handlePagination(i + 1)}
                          style={{
                            borderRadius: "7px", fontSize: "12px", padding: "4px 10px",
                            border: pageValue === i + 1 ? "none" : "1.5px solid #dde3ef",
                            background: pageValue === i + 1 ? "linear-gradient(135deg, #0f2557, #1a3a8f)" : "white",
                            color: pageValue === i + 1 ? "white" : "#374151",
                            fontWeight: pageValue === i + 1 ? "700" : "400"
                          }}
                        >
                          {i + 1}
                        </Link>
                      </li>
                    ))}
                    <li className={`page-item ${pageValue === suppliers?.paginationInfo?.totalPage ? "disabled" : ""}`}>
                      <Link className="page-link" onClick={() => handlePagination(pageValue + 1)}
                        style={{ borderRadius: "7px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "12px", padding: "4px 10px" }}>
                        <i className="fa-solid fa-angle-right"></i>
                      </Link>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal size="lg" show={show} onHide={onHideModel} backdrop="static" keyboard={false}>
        <Modal.Header closeButton style={{ border: "none", padding: "20px 24px 0" }}>
          <div className="d-flex align-items-center gap-3">
            <div style={{
              width: "40px", height: "40px", borderRadius: "10px",
              background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
            }}>
              <i className="bi bi-truck text-white" style={{ fontSize: "18px" }}></i>
            </div>
            <div>
              <Modal.Title style={{ fontSize: "17px", fontWeight: "700", color: "#0f2557", lineHeight: 1.2 }}>
                {addUpdateSupplierHeading} Supplier
              </Modal.Title>
              <p className="mb-0" style={{ fontSize: "12px", color: "#8a9ab5" }}>Fill in the details below</p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: "20px 24px 24px" }}>
          {modalLoading ? <ContentLoader loaderType="circleSpin" /> : (
            <form onSubmit={onSupplierSubmit}>

              {/* Section: Basic Info */}
              <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #e8edf5" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-person-fill" style={{ color: "#1a3a8f", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3a8f", textTransform: "uppercase", letterSpacing: "0.7px" }}>Basic Info</span>
                </div>
                <div className="row g-2">
                  {[
                    { id: "txtSupplierPhone", label: "Mobile", name: "mobile", type: "text", icon: "bi-telephone", value: supplierDetail?.mobile },
                    { id: "txtSupplierPassword", label: "Password", name: "password", type: "text", icon: "bi-lock", value: supplierDetail?.password },
                  ].map(({ id, label, name, type, icon, value }) => (
                    <div className="col-md-3" key={id}>
                      <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                          <i className={`bi ${icon}`} style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                        </span>
                        <input
                          type={type}
                          className="form-control form-control-sm"
                          id={id}
                          placeholder={label}
                          name={name}
                          onChange={handleChange}
                          value={value || ""}
                          style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Section: Agency Info */}
              <div className="p-3 mb-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #e8edf5" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-building" style={{ color: "#1a3a8f", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3a8f", textTransform: "uppercase", letterSpacing: "0.7px" }}>Agency Info</span>
                </div>
                <div className="row g-2">
                  {[
                    { id: "txtSupplierEmail", label: "Email", name: "email", icon: "bi-envelope", value: supplierDetail?.email, col: 4 },
                    { id: "txtSupplier_AgencyName", label: "Agency Name", name: "agency_name", icon: "bi-briefcase", value: supplierDetail?.agency_name, col: 4 },
                    { id: "txtSupplier_HeadPersonName", label: "Head Person", name: "head_person", icon: "bi-person-badge", value: supplierDetail?.head_person, col: 4 },
                  ].map(({ id, label, name, icon, value, col }) => (
                    <div className={`col-md-${col}`} key={id}>
                      <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>{label}</label>
                      <div className="input-group input-group-sm">
                        <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                          <i className={`bi ${icon}`} style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                        </span>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          id={id}
                          placeholder={label}
                          name={name}
                          onChange={handleChange}
                          value={value || ""}
                          style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Section: Location */}
              <div className="p-3 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #e8edf5" }}>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <i className="bi bi-geo-alt-fill" style={{ color: "#1a3a8f", fontSize: "13px" }}></i>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3a8f", textTransform: "uppercase", letterSpacing: "0.7px" }}>Location</span>
                </div>
                <div className="row g-2 align-items-end">

                  {/* Address full width */}
                  <div className="col-md-12">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>Address</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-map" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="txtSupplierAddress"
                        placeholder="Full Address"
                        name="address"
                        onChange={handleChange}
                        value={supplierDetail?.address || ""}
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                      />
                    </div>
                  </div>

                  {/* Pincode */}
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>Pin Code</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-pin-map" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="txtPinCode"
                        placeholder="Pin Code"
                        name="pincode"
                        maxLength={6}
                        value={supplierDetail?.pincode || ""}
                        onChange={handlePincodeChange}
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                      />
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>City</label>
                    <select
                      className="form-select form-select-sm"
                      id="txtCity"
                      name="city"
                      onChange={handleChange}
                      value={supplierDetail?.city || ""}
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: "white", fontSize: "13px" }}
                    >
                      {supplierDetail?.city &&
                        !pincodeDropdown?.cities?.some((city) => city === supplierDetail.city) && (
                          <option value={supplierDetail.city}>{supplierDetail.city}</option>
                        )}
                      {pincodeDropdown?.cities?.map((city) => (
                        <option value={city} key={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* State */}
                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>State</label>
                    <select
                      className="form-select form-select-sm"
                      id="txtState"
                      name="state"
                      onChange={handleChange}
                      value={supplierDetail?.state || ""}
                      style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", background: "white", fontSize: "13px" }}
                    >
                      {supplierDetail?.state &&
                        !pincodeDropdown?.states?.some((state) => state === supplierDetail.state) && (
                          <option value={supplierDetail.state}>{supplierDetail.state}</option>
                        )}
                      {pincodeDropdown?.states?.map((state) => (
                        <option value={state} key={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Submit */}
                  <div className="col-md-3 d-flex justify-content-end">
                    <button
                      type="submit"
                      className="btn btn-sm text-white fw-semibold d-flex align-items-center gap-2 px-4 w-100 justify-content-center"
                      disabled={btnAddUpdateSupplierDisabled}
                      style={{
                        background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                        borderRadius: "8px", border: "none",
                        boxShadow: "0 4px 12px rgba(15,37,87,0.3)",
                        fontSize: "13px", height: "34px"
                      }}
                    >
                      {btnAddUpdateSupplierDisabled
                        ? <><span className="spinner-border spinner-border-sm"></span> Please Wait</>
                        : <><i className="bi bi-floppy-fill"></i> {btnAddUpdateSupplierText}</>
                      }
                    </button>
                  </div>

                </div>
              </div>

            </form>
          )}
        </Modal.Body>
      </Modal>

      {/* Hidden CSV Link for web browser downloads */}
      <CSVLink
        data={exportData.data}
        filename={exportData.fileName}
        className="text-decoration-none"
        ref={csvLinkRef}
        target="_blank"
        style={{ display: 'none' }}
      />
    </>
  )
}

export default SupplierList